export default __webpack_public_path__ + "static/media/ap3.73567f92.png";